<nav
  [attr.aria-label]="i18n.Core_Breadcrumb"
  class="before:tw-content-[` `] after:tw-content-[` `] tw-relative tw-bg-neutral-100 tw-px-4 tw-py-1 tw-text-xs before:tw-absolute before:-tw-left-[100%] before:tw-bottom-0 before:tw-right-[100%] before:tw-top-0 before:tw-block before:tw-h-full before:tw-bg-neutral-100 after:tw-absolute after:-tw-right-[100%] after:tw-bottom-0 after:tw-left-[100%] after:tw-top-0 after:tw-block after:tw-h-full after:tw-bg-neutral-100"
>
  <ol class="tw-flex tw-items-center">
    @for (item of items(); track item.label; let isLast = $last) {
      <li
        class="after:tw-mx-2 after:tw-text-neutral-600 after:tw-content-['/'] last:after:tw-content-none"
      >
        <a
          (click)="onItemClick(item)"
          [routerLink]="isLast ? currentUrl() : item.link"
          [attr.aria-current]="isLast ? 'page' : null"
          [ngClass]="{
            'tw-btn-tertiary': !isLast,
            'tw-btn-tertiary-neutral': isLast,
          }"
        >
          {{ item.label }}
        </a>
      </li>
    }
  </ol>
</nav>
